/**
* Composition for category/products logic
*/
export default function () {
  const { query } = useRoute()
  const { useCustomCookie } = useCustomTools()
   
  /*
  * Default Params
  */
  const defaultParams = {
    limit: 26,
    page: 1
  }
    
  /**
  * View Type
  */
  const viewType = useState('viewType', () => {
    if (useCustomCookie('viewType').value) {
      return useCustomCookie('viewType').value
    } else {
      return 'viewGrid'
    }
  })
    
  /**
  * Choose View Type and save to Session
  */
  const chooseViewType = (type) => {
    viewType.value = useCustomCookie('viewType').value = type
  }
    
  /*
  * Products Filters Info
  */
  const paramsProducts = useState('paramsProducts', () => null)

  /*
  * Resert Products Filters Info
  */
  const updateParamsFromQuery = () => {
    paramsProducts.value = {
      limit: defaultParams.limit,
      page: defaultParams.page,
      filter: query.filter ? query.filter : '',
      'filters[pmin]': query['filters[pmin]'] ? query['filters[pmin]'] : '',
      'filters[pmax]': query['filters[pmax]'] ? query['filters[pmax]'] : '',
      search: query.search ? query.search : ''
    }
  }

  /*
  * Resert Filters
  */
  const resetParams = () => {
    paramsProducts.value = {
      limit: defaultParams.limit,
      page: defaultParams.page
    }
  }
    
  /*
  * Reactive Params
  */
  const paramsObj = computed(() => {
    return filterNonEmptyParams(paramsProducts.value)
  })
    
  /*
  * Return Params
  */
    
  return {
    viewType,
    chooseViewType,
        
    paramsProducts,
    updateParamsFromQuery,
    resetParams,
    paramsObj
  }
}
